import React, { useEffect, useState } from 'react'
import './home-content.styles.scss'

import { useParams, useNavigate, useLocation } from 'react-router-dom'
import UIkit from 'uikit'
import IsbeForm from '@/forms/isbe.form.json'
import ElnForm from '@/forms/eln.form.json'
import Form from './form.component'
import { FormTypes } from '@/forms/formTypes'
import PdfDisplay from './pdf-display.component'

import { useSelector } from 'react-redux'

import { UseCloudFunction } from '@/utils/firebase.utils'
import CheckInOutContent from '../../EVAL/check-in-out-content.component'

const HomeContent = ({ setPlatform }) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const { id } = useParams()
  const userProfile = useSelector(state => state.userData.userProfile);
  const [noId, setNoId] = useState(false)
  const [evalData, setEvalData] = useState(null)
  const [formContent, setFormContent] = useState(null)
  const [fullForms, setFullForms] = useState({
    "isbe": IsbeForm,
    "eln": ElnForm
  })
  const [cpduData, setCpduData] = useState(null)
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // console.log(id)
    if (!id) {
      setNoId(true)
      // console.log('checking for id')
      return;
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setNoId(true)
      return;
    }
    setTimeout(() => {
      getEvalDoc(id);
    }, 700);
  }, [id]);

  async function getEvalDoc(id) {
    if (!userProfile) {
      console.log('no user profile');
      navigate(`/${id}`);
      return;
    }
    const getEval = await UseCloudFunction(
      'getEvalCheckCompletion',
      {
        'cst_key': userProfile.id,
        'evalId': id
      }
    )
    console.log(getEval);
    if (getEval.evalData) {
      setEvalData(getEval.evalData);
      if (!getEval.evalData.platform) {
        console.log(getEval.evalData.type);
        if (getEval.evalData.type !== 'eln' && getEval.evalData.type !== 'ipa') {
          const pf = FormTypes[getEval.evalData.type]?.cat[0];
          console.log(pf);
          setPlatform(pf);
        } else {
          setPlatform(getEval.evalData.type);
        }
      } else {
        setPlatform(getEval.evalData.platform);
      }
      console.log(getEval.evalData)
      if (getEval.evalData.source === 'none') return;
      // console.log(FormTypes[getEval.evalData.type])
      const formPartTitleArr = FormTypes[getEval.evalData.type]?.comps || [];
      if (getEval.evalData.isbe === false) {

      } else {
        formPartTitleArr.unshift('isbe');
      }

      if (getEval.evalData.customEval) {
        formPartTitleArr.concat(getEval.evalData.customEval);
      }
      let formParts = [];
      console.log(formPartTitleArr);
      for (let c of formPartTitleArr) {
        if (!fullForms[c]) continue;
        formParts = [...formParts, ...Object.values(fullForms[c].sections)];
      }
      
      console.log(formParts)
      // for ()
      setFormContent(formParts)
    } else {
      setNoId(true);
      if (getEval.message === 'already completed' && !location.pathname.includes('/construction')) {
        UIkit.modal.alert('Sorry, you have already completed this evaluation. Check your list of completed evaluations to make sure this is correct.')
          .then(() => {
            navigate('/home')
          })

      } if (getEval.message === 'no eval exists' && !location.pathname.includes('/construction')) {
        UIkit.modal.alert('Sorry, this evaluation link does not match with any of our exisiting evaluations.')
          .then(() => {
            navigate('/home')
          })
      }
    }
  }

  return (

    <div className='home-content'>
      {
        (evalData && evalData.source !== 'checkinout')
          ?
          <div className={`form-container ${screenSize === 'mobile' ? 'mobile' : 'g-card'
            }`}>
            <h3>
              <span className='meta'>Evaluation:</span>
              <br />
              <b>{evalData.item.title}</b>
            </h3>
            <hr />
            <h4>
              <b>Title:</b> {evalData.item.title}<br />
              <b>Training Type:</b> {
                (evalData.source === 'bridge')
                  ? 'ELN Course'
                  : (evalData.source === 'aa')
                    ? 'Admin Academy'
                    : (evalData.source === 'mc')
                      ? 'Micro-Credential'
                      : (evalData.source === 'zoomWebinar')
                        ? 'Zoom Webinar'
                        : ''
              }
            </h4>
            <hr />
            {
              (formContent)
                ?
                <div>
                  <Form
                    evalData={evalData}
                    formContent={formContent}
                    setFormContent={setFormContent}
                    userProfile={userProfile}
                    setCpduData={setCpduData} />
                </div>
                :
                <div>
                  <PdfDisplay
                    cpduData={cpduData}
                    source={evalData.source} />
                </div>
            }
          </div>
          :
          <CheckInOutContent
            evalData={evalData}
            formContent={formContent} />
      }

      <div className="g-space-1"></div>
    </div>
  )
}

export default HomeContent;